module.exports = __webpack_public_path__ + "media/images/icons/SVG/048-62fa222789c175ccf7e1e6e927d4bb68.svg";